module.exports = __webpack_public_path__ + "img/title-2.d0846236.png";